import { defineComponent } from "vue";
import { mapState } from "pinia";

import { useApp } from "../../App/useApp";
import { ApplicationEnum } from "../../../enums/ApplicationEnum";

import HuvSfvStatusReportHos from "./components/HuvSfvStatusReportHos/HuvSfvStatusReportHos.vue";

export default defineComponent({
    components: {
        HuvSfvStatusReportHos
    },

    data(vm) {
        return {
            tabs: [
                {
                    name: "Hospice",
                    id: ApplicationEnum.AxxessHospiceFE
                }
            ],
            hopeDeclaration: `<b>Description: </b>Displays a list of patients with unscheduled or incomplete HOPE Update Visits and Symptom Follow-Up Visits, along with the number of days remaining before completion.<br/>
            <b>Parameters: </b>Branch, Team, Task, HUV/SFV, Task Status.<br/>
            <b>Report Includes: </b>Branch, Team, Patient Last Name, Patient First Name, MRN, Patient Status, Task, HUV/SFV, Task Status, Visit Date, Admission Date, Days Remaining.`
        };
    },
    mounted() {
        if (!this.showHosNav) {
            this.$router.push("/help");
        }
    },
    computed: {
        ...mapState(useApp, ["showHosNav"])
    },
    methods: {
        goToReportCenter() {
            this.$router.push({ name: "report-center" });
        }
    }
});
